/*
 * Public API Surface of parser
 */

export * from './lib/parser.service';
